<template>
	<div class='Test'>
		<p>welcome to my test page!</p>

		<vue-aliplayer-v2
			:ref="`VueAliplayerV2_0`"
			class="VueAliplayerV2Style"
			:options="{
				...videoOptions,
				cover: 'https://inews.gtimg.com/newsapp_bt/0/14347237476/1000'
			}"
			source="https://stream7.iqilu.com/10339/upload_transcode/202002/18/20200218114723HDu3hhxqIT.mp4"
			@ready="handleVideoReady"
		/>
	</div>
</template>
<script>

export default {
	name: 'Test',
	components: {

	},
	data() {
		return {
			videoOptions: {
				autoplay: false,
				// playsinline: true,
				// useH5Prism: true,
				// isLive: false,
				// cover: 'https://inews.gtimg.com/newsapp_bt/0/14347237476/1000'
			},
		};
	},
	mounted() {

	},
	methods: {
		handleVideoReady(e){
			console.log('handleVideoReady')

			// const cover_img = e.target.getAttribute('cover')
			// console.log('cover_img: ', cover_img)
			// e.target.__vue__.setCover(cover_img)

			// console.log(e.target.children.filter(i => i.getAttribute('class').indexOf('prism-cover')))

			// const test_img_url = 'https://inews.gtimg.com/newsapp_bt/0/14347237476/1000'

			// console.log('prism-cover: ', Array.from(e.target.childNodes).filter(i => i.getAttribute('class') == 'prism-cover'))

			// e.target.__vue__.setCover(test_img_url)

			// Array.from(e.target.childNodes).filter(i => i.getAttribute('class') == 'prism-cover')[0].style.backgroundImage = `url('${test_img_url}')`
			// Array.from(e.target.childNodes).filter(i => i.getAttribute('class') == 'prism-cover')[0].style.display = 'block'

		}
	},
}
</script>
<style lang='stylus' scoped>
	.Test
		width: 100%
</style>
